module.exports = __webpack_public_path__ + "static/media/1_checkout.714301da.svg";